export default "__VITE_ASSET__ERm10QfF__"